import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Container,
  Stack,
  useTheme,
  alpha
} from '@mui/material'
import { Login, PersonAdd } from '@mui/icons-material'

interface MarketingHeaderProps {
  onLogin: () => void
  onSignUp: () => void
}

export default function MarketingHeader({ onLogin, onSignUp }: MarketingHeaderProps) {
  const theme = useTheme()

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        bgcolor: alpha('#ffffff', 0.95),
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid',
        borderColor: 'divider'
      }}
    >
      <Container maxWidth="lg">
        <Toolbar sx={{ px: 0 }}>
          <Typography
            variant="h6"
            component="div"
            sx={{
              flexGrow: 1,
              fontWeight: 'bold',
              color: theme.palette.primary.main,
              fontSize: '1.5rem'
            }}
          >
            Taylin Digital Helpdesk
          </Typography>

          <Stack direction="row" spacing={1}>
            <Button
              variant="text"
              startIcon={<Login />}
              onClick={onLogin}
              sx={{
                color: theme.palette.text.primary,
                '&:hover': {
                  bgcolor: alpha(theme.palette.primary.main, 0.08)
                }
              }}
            >
              Sign In
            </Button>
            <Button
              variant="contained"
              startIcon={<PersonAdd />}
              onClick={onSignUp}
              sx={{
                px: 3,
                '&:hover': {
                  transform: 'translateY(-1px)',
                  boxShadow: theme.shadows[4]
                },
                transition: 'all 0.2s ease'
              }}
            >
              Get Started
            </Button>
          </Stack>
        </Toolbar>
      </Container>
    </AppBar>
  )
}